export default __webpack_public_path__ + "static/media/bags.ad3496b5.JPG";